import * as Config from '../config';

import useGetFromApiSearch from './useGetFromApiSearch';

const useLabels = (id, pathApi, isBaseRootApi = true, perPage = 100) => {
  const [response] = useGetFromApiSearch(id, pathApi, isBaseRootApi, `labels`, perPage);
  let result = (response) ? { ...response } : null;

  if (response) {
    result.items = (response.items) ? response.items.map( isBaseRootApi ? Config.formattedLabel : Config.formattedLabelSearchV1) : null;
  }

  return [result];
};

export default useLabels;
